module.exports = __webpack_public_path__ + "img/l1.dca43f19.png";